<template>
	<div class="page-container">
		<head-top head-title="登录" goBack="true"></head-top>
		
		<div class="login-page">
			<div class="login-title">登录后继续操作</div>
			<div class="login-desc">使用邮箱账号登录返利</div>

			<div class="login-body">
				<div class="input-group">
					<input class="input-field" name="account" v-model="form.account" placeholder="请输入邮箱账号" type="text" />
				</div>
				<div class="input-group">
					<input class="input-field" name="password" v-model="form.pwd" type="password" placeholder="请输入密码" />
				</div>
				<div class="input-group flex_a">
					<input class="input-field captcha-input" name="code" v-model="form.code" placeholder="请输入验证码" type="text" />
					<img class="captcha-image" :src="captchaImage" @click="loadCaptcha" />
				</div>
			
				<button class="login-btn" @click="handleLogin">登录</button>

				<div class="login-footer flex_c">
					<div>
						<span>还没有账号？</span>
						<span class="register-link" @click="goRegister">立即注册</span>
					</div>

					<div class="forgot-link" @click="goForgotPassword">忘记密码</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		getCaptchaImage,
		loginMember,
		saveLogin,
		getLoginMember 
	} from '@/apis/api.js'

	export default {
		name: 'Login',
		components: {
			headTop: headTop
		},
		data() {
			return {
				captchaImage: '',
				form: {
					account: '',
					pwd: '',
					code: '',
					uuid: ''
				}
			}
		},
		mounted() {
				if (getLoginMember()) {
					this.$router.replace('/')
					return
				}
				this.loadCaptcha()
			},
		methods: {
			async loadCaptcha() {
				const res = await getCaptchaImage()
				this.form.uuid = res.uuid || ''
				this.captchaImage = res.img ? 'data:image/jpeg;base64,' + res.img : ''
			},
			handleLogin() {
				if (!this.form.account || !this.form.pwd || !this.form.code) {
					this.$toast('请填写完整信息')
					return
				}
				this.$toast.loading({ message: '登录中...', duration: 0 })
				loginMember(this.form)
					.then(res => {
						this.$toast.clear()
						saveLogin(res)
						this.$toast.success('登录成功')
						setTimeout(() => {
							const redirect = this.$route.query.redirect
											if (redirect) {
												this.$router.go(-1)
											} else {
												this.$router.replace('/')
											}
						}, 500)
					})
					.catch(e => {
						this.$toast.clear()
						if (e.handled) return
						this.$toast(e.msg || '登录失败')
						this.form.code = ''
						this.loadCaptcha()
					})
			},
			goForgotPassword() {
				this.$router.push('/forgot_password')
			},
			goRegister() {
				this.$router.push('/register')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;
		
		.login-page {
			padding: 50px 28px 0;
			
			.login-title {
				color: #222222;
				font-size: 24px;
				font-weight: bold;
			}
			
			.login-desc {
				margin-top: 10px;
				color: #888888;
				font-size: 14px;
			}
			
			.login-body {
				margin-top: 55px;
				
				.input-group {
					height: 46px;
					margin-bottom: 14px;
					border-bottom: 1px solid #e4e7ed;
					box-sizing: border-box;

					.input-field {
						width: 100%;
						height: 46px;
						line-height: 46px;
						color: #222222;
						font-size: 15px;					

						&::placeholder {
							color: #999;
						}
					}
					
					.captcha-input {
						flex: 1 !important;
						width:auto !important;
					}
					
					.captcha-image {
						flex:none;
						width: 95px;
						height: 36px;
						border-radius: 3px;
						background: #ffffff;
						cursor: pointer;
					}
				}
				
				.login-btn {
					height: 44px;
					line-height: 44px;
					margin-top: 20px;
					color: #ffffff;
					background: #e33737;
					border-radius: 22px;
					font-size: 17px;
					font-weight: bold;
					width: 100%;
				}
				
				.login-footer {
					margin-top: 20px;
					color: #999999;
					font-size: 13px;

					.forgot-link {
						cursor: pointer;
						color: #e33737;
						font-weight: bold;
					}

					.register-link {
						cursor: pointer;
						margin-left: 8px;
						color: #e33737;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>